<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-04-12 15:57:44
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/media/kwai/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="all">全部账号</el-menu-item>
          <el-menu-item index="blacklist">黑名单</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <media-filter
          :media-type="MEDIA_TYPE.KWAI"
          :tab-data="activeIndex"
          @getQueryData="dealQueryData"
        ></media-filter>
        
        <media-list
          platformValue="快手"
          v-if="activeIndex=='all'"
          key="all" 
          :media-type="MEDIA_TYPE.KWAI" 
          :query-data="queryData" 
          :tab-data="activeIndex"
        ></media-list>
        <media-list 
          v-if="activeIndex=='blacklist'"
          platformValue="black"
          key="blacklist" 
          :media-type="MEDIA_TYPE.KWAI" 
          :query-data="queryData" 
          :tab-data="activeIndex"
        ></media-list>
      </div>
    </div>
  </div>
</template>

<script>
import mediaFilter from "../component/filter";
import mediaList from "../component/list";
export default {
  components: {
    mediaFilter,
    mediaList
  },
  data() {
    return {
      activeIndex: "all",
      queryData: {}
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeIndex = this.$route.query.tab;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealQueryData(data) {
      this.queryData = data;
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/styles/media/index.scss";
</style>